import { registerDecorator } from "class-validator";
import type { ValidationOptions } from "class-validator/types/decorator/ValidationOptions";

/**
 * Validates that a string is a supported trip reference.
 */
export function IsTripReference(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: "isTripReference",
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: {
                validate(value: any) {
                    return (
                        typeof value === "string" && // trip reference is a string
                        (value.length === 6 || value.length === 25) && // either 6 or 25 characters long
                        /^[a-fA-F0-9]{6}|[a-z0-9]{25}$/.test(value) // either derived from order or ride identifier, or it is pool trip id
                    );
                },
            },
        });
    };
}
